import { useCallback } from 'react';
import { useAppLocale } from './useAppLocale';
import { pathWithLocale } from '../lib/locale';

/** Returns a function to build locale-prefixed paths (e.g. `/faq` → `/ko/faq`). */
export function useLocalizedPath() {
  const locale = useAppLocale();
  return useCallback((path: string) => pathWithLocale(path, locale), [locale]);
}
